export default "__VITE_ASSET__CgTSAfja__"